import React, { Fragment } from 'react';
import { Loading } from '@/components';
import EventReportProduct from '@/model/EventReportProduct';
import { States } from '@/helpers/common/states';
import { colors } from '@/styles/colors';

export interface SaleSubPdvContentProps {
  state: States;
  product: EventReportProduct;
  steps: any[];
  handleClickStep: (step: number) => void;
}

export const SaleProdutContent: React.FC<SaleSubPdvContentProps> = ({
  state,
  steps,
  handleClickStep,
}) => (
  <Fragment>
    <Loading isVisible={state === States.loading} />

    {/* Topbar com Titulo de Vendas por Produtos */}
    <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
      <div>
        <h5 style={{ fontWeight: 600, color: '#212529', margin: 0 }}>Vendas por Produtos</h5>
        <span style={{ fontSize: '13px', color: '#6c757d' }}>
          Resumo financeiro e detalhamento de vendas de produtos
        </span>
      </div>
    </div>

    {/* Card Container no mesmo design do resumo de vendas do header */}
    <div
      style={{
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        padding: '20px 24px',
        marginBottom: '24px',
        border: '1px solid #e9ecef',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.03)',
      }}
    >
      <h6
        style={{
          fontSize: '14px',
          fontWeight: 600,
          color: '#495057',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          marginBottom: '16px',
        }}
      >
        Selecione o tipo de relatório
      </h6>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '12px',
          width: '100%',
        }}
      >
        {steps.map((step, index) => {
          const isCurrent = step.status === 'current';
          return (
            <button
              key={`substep-${index}`}
              type="button"
              onClick={() => handleClickStep(index)}
              style={{
                backgroundColor: isCurrent ? '#ffffff' : '#f8f9fa',
                color: isCurrent ? colors.lightBlue : '#495057',
                border: isCurrent ? `2px solid ${colors.lightBlue}` : '1px solid #e9ecef',
                boxShadow: isCurrent
                  ? '0 4px 10px rgba(27, 72, 128, 0.12)'
                  : '0 2px 4px rgba(0, 0, 0, 0.02)',
                borderRadius: '10px',
                padding: '14px 16px',
                fontSize: '14px',
                fontWeight: isCurrent ? 600 : 500,
                textAlign: 'center',
                cursor: 'pointer',
                transition: 'all 0.2s ease-in-out',
                userSelect: 'none',
              }}
              onMouseEnter={e => {
                if (!isCurrent) {
                  e.currentTarget.style.backgroundColor = '#ffffff';
                  e.currentTarget.style.borderColor = '#1b488080';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }
              }}
              onMouseLeave={e => {
                if (!isCurrent) {
                  e.currentTarget.style.backgroundColor = '#f8f9fa';
                  e.currentTarget.style.borderColor = '#e9ecef';
                  e.currentTarget.style.transform = 'translateY(0)';
                }
              }}
            >
              {step.title}
            </button>
          );
        })}
      </div>
    </div>

    {/* Conteúdo da Aba Selecionada */}
    <div>
      {steps.map((step, index) => {
        if (step.status === 'current') {
          return <React.Fragment key={index}>{step.component}</React.Fragment>;
        }
        return null;
      })}
    </div>
  </Fragment>
);
